import React from 'react';
import { Button, Space, Spin } from 'antd';
import Dropdown from 'antd/es/dropdown/dropdown';
import chevronDown from 'assets/icons/chevron-down.svg';
import 'baseComponents/DropdownSelectComponent/dropdownSelectComponent.scss';

type DropdownSelectType = {
  key: string;
  label: string;
};
interface Props {
  selectLabelValue: string;
  onChange?: (e: any) => void;
  items: DropdownSelectType[];
  disabled?: boolean;
  loading?: boolean;
}

export const DropdownSelectComponent: React.FC<Props> = (props) => {
  return (
    <Dropdown
      disabled={props.disabled || props.loading}
      overlayClassName='selectable-dropdown-container'
      menu={{
        items: props.items,
        selectable: true,
        defaultSelectedKeys: ['3'],
        onClick: props.onChange,
      }}
    >
      <Button className='selectable-dropdown-button'>
        <Space>
          {props.loading && <Spin size='small' />}
          {props.selectLabelValue}
          <img src={chevronDown} alt='chevron down' />
        </Space>
      </Button>
    </Dropdown>
  );
};
